<script lang="ts">
    import {
        REWARDS_REWARD_TYPE,
        REWARDS_REWARD_TYPES,
    } from "@apps/rewards/constants/rewardsRewardTypes";
    import type RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type { RewardsEarningRulesRewardEntity } from "@apps/rewards/modules/EarningRules/models/RewardsEarningRulesEntities";
    import type { RewardsReferralProgramRewardEntity } from "@apps/rewards/modules/ReferralProgram/models/RewardsReferralProgramEntities";
    import type { RewardsVipTiersRewardEntity } from "@apps/rewards/modules/VipTiers/entities/RewardsVipTiersEntities";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
    import HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";
    import { SvelteComponent } from "svelte";

    import RewardsWidgetDiscountReward from "./RewardsWidgetDiscountReward.svelte";
    import RewardsWidgetFreeProductReward from "./RewardsWidgetFreeProductReward.svelte";
    import RewardsWidgetGiftCardReward from "./RewardsWidgetGiftCardReward.svelte";
    import RewardsWidgetPointsReward from "./RewardsWidgetPointsReward.svelte";

    //Props
    export let reward:
        | RewardsVipTiersRewardEntity
        | RewardsEarningRulesRewardEntity
        | RewardsReferralProgramRewardEntity;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let amountFormatter: RewardsAmountFormatter;
    export let i18n: GwI18n;
    export let namespace: TranslationNamespaces;
    export let pointsNamespace: TranslationNamespaces;
    export let urlsBuilder: URLsBuilder;
    export let sanitizer: HTMLSanitizerInterface;

    const component: Record<REWARDS_REWARD_TYPE, typeof SvelteComponent> = {
        [REWARDS_REWARD_TYPES.points]: RewardsWidgetPointsReward,
        [REWARDS_REWARD_TYPES.discount]: RewardsWidgetDiscountReward,
        [REWARDS_REWARD_TYPES.giftCard]: RewardsWidgetGiftCardReward,
        [REWARDS_REWARD_TYPES.freeProduct]: RewardsWidgetFreeProductReward,
    };
</script>

<svelte:component
    this={component[reward.type]}
    {reward}
    {i18n}
    {amountFormatter}
    {currencyFormatter}
    {namespace}
    {pointsNamespace}
    {urlsBuilder}
    {sanitizer}
/>
